import React, { Component } from 'react';
import PropTypes from 'prop-types';

export default class NavButton extends Component{
	constructor(props){
		super(props);
		this.handleClick = this.handleClick.bind(this);
	}

	handleClick(e){ //method for handling navbutton click
		if(typeof(this.props.onClick) === 'function'){
			let theName = this.props.name.replace(/\s/g,"_");
			this.props.onClick(theName,this.props.type);
		}
	}

	render(){
		return(
			<div>
				<button style={{minHeight:'100%',marginTop:'0',marginBottom:'0'}} className={this.props.styles} onClick={this.handleClick} disabled={this.props.disable}>{this.props.name}</button>
			</div>
		);
	}
}

NavButton.propTypes = {
	styles: PropTypes.string,
	onClick: PropTypes.func,
	name: PropTypes.string.isRequired
};


// WEBPACK FOOTER //
// ./src/component/NavButton.js